import { render, staticRenderFns } from "./DeliveriesModal.vue?vue&type=template&id=702d291f&"
import script from "./DeliveriesModal.vue?vue&type=script&lang=js&"
export * from "./DeliveriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports